import React from 'react';
import Layout from '../../components/UI/Layout/Layout' 
import NewUserList from '../../components/Entity/NewUsers/List/List';

const NewUsersPage = () => {
  return <Layout title={'ახალი მომხმარებლები'} fullwidth={0}>
       <NewUserList></NewUserList>
   </Layout>;
}

export default NewUsersPage;
